const FIRST_PAGE = 1;
const MIN_LIMIT = 10;
const MIDDLE_LIMIT = 20;
const MAX_LIMIT = 100;
export { FIRST_PAGE, MIN_LIMIT, MIDDLE_LIMIT, MAX_LIMIT };
